module.exports = __webpack_public_path__ + "img/about_ali.5f000c25.png";